import {ReactNode} from 'react';

import {FileUploadProviderBase} from '../../core/providers/FileUploadProvider';
import {
  useThreadsAnalytics,
  useThreadsConfig,
  useThreadsProfile,
} from '../app/hooks';

type Props = {
  children: ReactNode;
};

export function ThreadsFileUploadProvider({children}: Props) {
  const config = useThreadsConfig();
  const profile = useThreadsProfile();
  const analytics = useThreadsAnalytics();
  const {visitor, merchant, livemode} = profile;
  const {
    urls: {uploadsHost},
  } = config;

  return (
    <FileUploadProviderBase
      uploadsHost={uploadsHost}
      visitor={visitor}
      merchant={merchant}
      livemode={livemode}
      analytics={analytics}
    >
      {children}
    </FileUploadProviderBase>
  );
}
